import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fComp } from '../../utils/React.js';
import { IndicatorWrapper } from '../Indicator/IndicatorWrapper.js';
import { getThemeClass } from '../Theme/ThemePresentation.js';
import { mainClass } from './HeaderContainer.styles.js';

var defaultProps = {
  width: "page"
};
var HeaderContainerPresentation = fComp(function (props) {
  var _cleanupClassObject2, _cleanupClassObject3, _cleanupClassObject4;
  var noMargin = props.noMargin,
    className = props.className,
    logo = props.logo,
    topLeft = props.topLeft,
    topRight = props.topRight,
    bottomLeft = props.bottomLeft,
    bottomRight = props.bottomRight,
    activeElement = props.activeElement,
    isMobile = props.isMobile,
    isFullUnderline = props.isFullUnderline,
    hasOpenFlyout = props.hasOpenFlyout,
    progress = props.progress,
    width = props.width,
    topLeftMaxWidth = props.topLeftMaxWidth,
    isSticky = props.isSticky,
    isHidden = props.isHidden,
    scrollPosition = props.scrollPosition,
    theme = props.theme,
    onClick = props.onClick,
    segmentLabel = props.segmentLabel,
    mainContainerRightTopRef = props.mainContainerRightTopRef,
    mainContainerRightBottomRef = props.mainContainerRightBottomRef;
  var height = isMobile && 16 || !bottomLeft && !bottomRight && 22 || 32;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject(_defineProperty({}, "".concat(mainClass, "__sticky-").concat(height), isSticky))
  }), /*#__PURE__*/React.createElement("header", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, className, !!className), _defineProperty(_cleanupClassObject2, mainClass, true), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__mobile"), isMobile), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__double-line"), bottomLeft || bottomRight), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__").concat(width), true), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__height-").concat(height), true), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__sticky"), isSticky), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__hide"), isHidden), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__flyout"), hasOpenFlyout), _defineProperty(_cleanupClassObject2, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__bg"), !theme), _defineProperty(_cleanupClassObject2, getThemeClass(theme, "header"), theme), _cleanupClassObject2)),
    style: {
      top: scrollPosition ? -scrollPosition : undefined
    },
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(mainClass, "-wrapper"), true), _defineProperty(_cleanupClassObject3, "".concat(mainClass, "-wrapper__flyout"), hasOpenFlyout), _cleanupClassObject3))
  }, logo && /*#__PURE__*/React.createElement("div", {
    className: "".concat(mainClass, "-logo"),
    style: !isMobile ? {
      transform: "translateY(".concat(scrollPosition * 5 / 8, "px) scale(").concat(1.0 - scrollPosition / 130, ")")
    } : {}
  }, logo), /*#__PURE__*/React.createElement("div", {
    className: "".concat(mainClass, "-main")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(mainClass, "-row")
  }, /*#__PURE__*/React.createElement("nav", {
    className: "".concat(mainClass, "-group ").concat(mainClass, "-group-left"),
    style: topLeftMaxWidth && {
      maxWidth: topLeftMaxWidth
    }
  }, !isMobile && segmentLabel && /*#__PURE__*/React.createElement("div", {
    className: "".concat(mainClass, "-segment-label")
  }, segmentLabel), topLeft), /*#__PURE__*/React.createElement("nav", {
    className: "".concat(mainClass, "-group ").concat(mainClass, "-group-right"),
    ref: mainContainerRightTopRef
  }, topRight)), (bottomLeft || bottomRight) && /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject4 = {}, _defineProperty(_cleanupClassObject4, "".concat(mainClass, "-row"), true), _defineProperty(_cleanupClassObject4, "".concat(mainClass, "-row__logo"), true), _cleanupClassObject4))
  }, /*#__PURE__*/React.createElement("nav", {
    className: "".concat(mainClass, "-group ").concat(mainClass, "-group-left")
  }, bottomLeft), /*#__PURE__*/React.createElement("nav", {
    className: "".concat(mainClass, "-group ").concat(mainClass, "-group-right"),
    ref: mainContainerRightBottomRef
  }, bottomRight)))), (activeElement || isFullUnderline || progress !== undefined) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IndicatorWrapper, {
    activeElement: activeElement,
    isFullUnderline: isFullUnderline,
    progress: progress
  }))));
}, defaultProps);
HeaderContainerPresentation.displayName = "HeaderContainerPresentation";

export { HeaderContainerPresentation };
